import { CalendarHeart } from 'lucide-react';
import { getNextOccasion } from '@/utils/occasions';
import GiftGenieBar from '@/components/browse/GiftGenieBar';

export default function HeroSection({ onResults, onCreateQuestionnaire }) {
  const occasion = getNextOccasion();

  return (
    <div className="relative py-20 sm:py-32 overflow-hidden">
      {/* Background image, art-directed flat-lay in the brand palette
          (cream / peach / terracotta / sage), served from /public so it
          always loads. Brand-color fallback if the file fetch fails. */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundColor: '#9E6752',
          backgroundImage: 'url(/hero/hero-gifts.png)'
        }}
      />

      {/* Warm scrim, just enough to keep white text legible without
          muddying the photography. */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(42, 36, 30, 0.40) 0%, rgba(42, 36, 30, 0.46) 55%, rgba(42, 36, 30, 0.52) 100%)'
        }}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
        {/* Occasion-aware nudge */}
        <div
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-5 page-rise-1"
          style={{ background: 'rgba(254, 215, 165, 0.95)', boxShadow: '0 2px 12px rgba(0,0,0,0.18)' }}
          data-testid="occasion-pill"
        >
          <CalendarHeart className="w-4 h-4" style={{ color: '#9E6752' }} />
          <span className="text-xs sm:text-sm font-semibold tracking-wide" style={{ color: '#20212B' }}>
            {occasion.days === 0
              ? `${occasion.name} is today!`
              : `${occasion.name} is ${occasion.days} ${occasion.days === 1 ? 'day' : 'days'} away`}
          </span>
        </div>

        <h1
          className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl mb-4 sm:mb-6 leading-tight page-rise-1"
          style={{ fontFamily: 'Playfair Display, serif', color: 'white', fontWeight: '700', textShadow: '0 2px 18px rgba(0,0,0,0.35)' }}
        >
          Who are you{' '}
          <span style={{ fontFamily: 'Great Vibes, cursive', fontWeight: '400', color: '#FED7A5', fontSize: '1.05em' }}>shopping</span>
          {' '}for today?
        </h1>
        <p
          className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 px-2 page-rise-2"
          style={{ color: 'rgba(255,255,255,0.97)', maxWidth: '700px', margin: '0 auto 2rem', textShadow: '0 1px 10px rgba(0,0,0,0.4)' }}
        >
          Describe them in a sentence, get gift ideas in seconds.
        </p>

        <GiftGenieBar
          onResults={onResults}
          onCreateQuestionnaire={onCreateQuestionnaire}
        />
      </div>
    </div>
  );
}
